import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const HeadphonesIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 12, height = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2 7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H3.5C3.76522 6.5 4.01957 6.60536 4.20711 6.79289C4.39464 6.98043 4.5 7.23478 4.5 7.5V9C4.5 9.26522 4.39464 9.51957 4.20711 9.70711C4.01957 9.89464 3.76522 10 3.5 10H3C2.73478 10 2.48043 9.89464 2.29289 9.70711C2.10536 9.51957 2 9.26522 2 9V7.5ZM2 7.5V6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2C7.06087 2 8.07828 2.42143 8.82843 3.17157C9.57857 3.92172 10 4.93913 10 6V7.5M10 7.5C10 7.23478 9.89464 6.98043 9.70711 6.79289C9.51957 6.60536 9.26522 6.5 9 6.5H8.5C8.23478 6.5 7.98043 6.60536 7.79289 6.79289C7.60536 6.98043 7.5 7.23478 7.5 7.5V9C7.5 9.26522 7.60536 9.51957 7.79289 9.70711C7.98043 9.89464 8.23478 10 8.5 10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9V7.5Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
